import React from "react";

const Nav = () => {
  return (
    <nav className="header-menu">
      <ul>
        <li>
          <a href="#services">services</a>
        </li>
        <li>
          <a href="#projects">projects</a>
        </li>
        <li>
          <a href="#about">about</a>
        </li>
        <li>
          <a href="#contact">contact</a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
